<template>
  <div class="sort-container"
       :class="{sorted : selected,
               [status.direction] : selected,}"
       v-on:click="toggleStatus">
    <slot/>
  </div>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    props: {
      name: {
        type: String,
      },
      selectedItemName: {
        type: String,
      },
      direction: {
        type: String,
        default: "asc",
        validator: (val) => {
          return ["asc", "desc"].includes(val);
        },
      },
    },
    computed: {
      selected() {
        return this.name === this.selectedItemName;
      }
    },
    data: () => {
      return {
        status: {
          direction: "asc",
          name: "",
        },
      }
    },
    created() {
      this.status.name = this.name;
      this.status.direction = this.direction;
    },
    methods: {
      toggleStatus() {
        if (this.selected) {
          this.status.direction === "asc" ? this.status.direction = "desc" : this.status.direction = "asc";
        }
        this.$emit("sort", this.status);
      }
    },
  });
</script>

<style scoped>
  .sort-container {
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
  }

  .sorted::after {
    display: inline-block;
    content: "";
    border-style: solid;
    border-color: currentColor transparent;
    border-width: 0.5rem;
    border-radius: 0.5rem;
  }

  .sorted.asc::after {
    border-top-style: none;
  }

  .sorted.desc::after {
    border-bottom-style: none;
  }
</style>
